// extracted by mini-css-extract-plugin
module.exports = {"form-body":"FhhSearch_form-body__uUjtb","search-button":"FhhSearch_search-button__BV3Rl","search-button--error":"FhhSearch_search-button--error__yHy2g"};